import React from 'react';
import stylesP from './pearlDoser.module.css'
import { cl } from '../../../components/utils/utils';

function displayNutrientName(name) {
  if (name == null || String(name).trim() === '') return 'None';
  return name;
}

export default class JPlus extends React.Component {
  render() {
//     cl(this.props)
    const { config, editMode, onChange, jpIndex, enAdv, units } = this.props;
//     cl(this.props)
    const { name, modbusAddress, pumpers, cps } = config;

    const emitEdit = (field) => {
      onChange({ type: 'edit', jpIndex, value: field });
    };
    var jpNameStyle,jpNameClick
    if(enAdv){
      jpNameStyle={ cursor: 'pointer', color:"#0060C0" }
      jpNameClick=() => emitEdit('jpName')
    }
//     cl(this.props)

    return (
      <div>
        <div
          style={{ marginBottom: 12 }}
            className={[stylesP.pearlDoser].join(' ')}
          >
          <div>
            <strong>J+ Name</strong>{' '}
            {editMode === 'jpName' ? (
              <input
                id="editJpNameE"
                className={[stylesP.inlineCont].join(" ")}
                type="text"
                value={name}
                onChange={(e) => onChange({ type: 'jpName', jpIndex, value: e.target.value })}
              />
            ) : (
              <span
                id="editJpNameT"
                style={jpNameStyle}
                onClick={jpNameClick}>
                {name}
              </span>
            )}
          </div>
          {enAdv&&
            <div>
              <strong>Modbus Address</strong>{' '}
              {editMode === 'jpModbus' ? (
                <input
                  id="editJpModbusE"
                  type="number"
                  min={1}
                  max={255}
                  value={modbusAddress}
                  onChange={(e) => {
                    const raw = e.target.value;
                    if (raw === '') return;
                    const v = Number(raw);
                    if (Number.isNaN(v)) return;
                    onChange({ type: 'jpModbus', jpIndex, value: Math.floor(v) });
                  }}
                />
              ) : (
                <span
                  id="editJpModbusT"
                  style={{ cursor: 'pointer', color:"#0060C0" }} onClick={() => emitEdit('jpModbus')}>
                  {modbusAddress}
                </span>
              )}
            </div>
          }
        </div>

        <table style={{ borderCollapse: 'collapse' }}
          className={stylesP.initTab}
        >
          <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: 4 }}>Idx</th>
              <th style={{ border: '1px solid #ccc', padding: 4 }}>Nutrient Name</th>
              <th style={{ border: '1px solid #ccc', padding: 4 }}>
                {`Concentration (${units.c})`}</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 16 }, (_, index) => {
              const pumper = pumpers[index] || {};
              const nutrientName = pumper.nutrientName;
//               const nuteEditName=(nutrientName=="None")?"":nutrientName
              const concentration = pumper.concentration;
              const rowGray = concentration === 0;
              const rowStyle = rowGray ? { backgroundColor: '#e8e8e8' } : {};
              var nuteNameStyle,nuteNameClick
//               cl(enAdv)
              if(enAdv){
                nuteNameStyle={ cursor: 'pointer', color:"#0060C0" }
                nuteNameClick=() => emitEdit('nuteName')
              }

              if (enAdv||(nutrientName&&(nutrientName!="None"))){
                return (
                  <tr key={index} style={rowStyle}>
                    <td style={{ border: '1px solid #ccc', padding: 4 }}>{index+1}</td>
                    <td style={{ border: '1px solid #ccc', padding: 4 }}>
                      {editMode === 'nuteName' ? (
                        <input
                          id="editJpNuteNameE"
                          type="text"
                          value={([null,"None"].includes(nutrientName)) ? '' : nutrientName}
                          onChange={(e) =>
                            onChange({ type: 'nuteName', jpIndex, index, value: e.target.value })
                          }
                        />
                      ) : (
                        <span
                          id="editJpNuteNameT"
                          style={nuteNameStyle}
                          onClick={nuteNameClick}
                        >
                          {displayNutrientName(nutrientName)}
                        </span>
                      )}
                    </td>
                    <td style={{ border: '1px solid #ccc', padding: 4}}
                          onClick={(editMode=="nuteConc")?null:
                            () => emitEdit('nuteConc')}

                    >
                      {editMode === 'nuteConc' ? (
                        <input
                          id="editJpNuteConcE"
                          type="number"
                          step="0.001"
                          min={0}
                          max={1000}
                          value={concentration == null ? '' : concentration}
                          onChange={(e) => {
                            const raw = e.target.value;
                            if (raw === '') return;
                            const num = Number(raw);
                            if (Number.isNaN(num)) return;
                            onChange({ type: 'nuteConc', jpIndex, index, value: num });
                          }}
                        />
                      ) : (
                        <span
                          id="editJpNuteConcT"
                          style={{ cursor: 'pointer', color:"#0060C0" }}
                        >
                          {concentration}
                        </span>
                      )}
                    </td>
                  </tr>
                );

              }
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
